<div class="rail" role="list">
  <button
    type="button"
    class="rail__chip"
    role="listitem"
    *ngFor="let workflow of workflows; trackBy: trackWorkflow"
    [attr.aria-label]="workflow.name + ' — ' + workflow.description"
    (pointerdown)="onPressStart(workflow)"
    (pointerup)="onPressEnd(workflow)"
    (pointerleave)="onPressCancel()"
    (pointercancel)="onPressCancel()"
    (keydown.enter)="runRequested.emit(workflow.id)"
  >
    <span class="rail__glyph" aria-hidden="true" [style.color]="accentFor(workflow)">{{ workflow.glyph }}</span>
    <span class="rail__name">{{ workflow.name }}</span>
    <span class="rail__test" *ngIf="workflow.testMode" aria-label="Test workflow" title="Test workflow — runs safely on sample data">
      <span class="rail__test-icon" aria-hidden="true">🧪</span>TEST
    </span>
  </button>

  <button
    *ngIf="overflowCount > 0"
    type="button"
    class="rail__chip rail__chip--more"
    [attr.aria-label]="overflowCount + ' more workflows'"
    (click)="overflowClicked.emit()"
  >
    +{{ overflowCount }}
  </button>
</div>
